import React, { useEffect, useState, useRef } from 'react';
import { MapPinIcon, SendIcon } from 'lucide-react';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export function Contact() {
  const formRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState({
    submitting: false,
    error: null
  });
  // Initialize EmailJS
  useEffect(() => {
    // Initialize EmailJS with your public key
    emailjs.init('yYknyf5fxU1lYKZmG');
  }, []);
  const handleChange = e => {
    const {
      id,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setStatus({
      submitting: true,
      error: null
    });
    try {
      // Create template parameters from form data
      const templateParams = {
        name: formData.name,
        email: formData.email,
        title: formData.subject || 'Website Inquiry',
        message: formData.message
      };
      console.log('Sending email with params:', templateParams);
      // Send email using EmailJS
      const response = await emailjs.send('service_az56ag5', 'template_1m8s3nv', templateParams);
      console.log('Email sent successfully:', response);
      // Show success toast
      toast.success("Message sent successfully! We'll get back to you soon.", {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
      setStatus({
        submitting: false,
        error: null
      });
      // Reset form after successful submission
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      console.error('Failed to send email:', error);
      // Show detailed error message
      const errorMessage = error.text || 'Failed to send message. Please try again later.';
      setStatus({
        submitting: false,
        error: errorMessage
      });
      // Show error toast with more details if available
      toast.error(errorMessage, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    }
  };
  return <section id="contact" className="py-20 bg-gray-50" data-id="element-62">
      <ToastContainer data-id="element-63" />
      <div className="container mx-auto px-4" data-id="element-64">
        <div className="text-center mb-16" data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-66">
            Get in Touch
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-6" data-id="element-67"></div>
          <p className="max-w-2xl mx-auto text-gray-600" data-id="element-68">
            Have a project in mind? We'd love to hear from you. Let's create
            something amazing together.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-12" data-id="element-69">
          <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8" data-id="element-70">
            <h3 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-71">
              Send us a message
            </h3>
            <form className="space-y-6" onSubmit={handleSubmit} ref={formRef} data-id="element-72">
              <div className="grid grid-cols-2 gap-6" data-id="element-73">
                <div data-id="element-74">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-75">
                    Name
                  </label>
                  <input type="text" id="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors" placeholder="Your name" required data-id="element-76" />
                </div>
                <div data-id="element-77">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-78">
                    Email
                  </label>
                  <input type="email" id="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors" placeholder="your@email.com" required data-id="element-79" />
                </div>
              </div>
              <div data-id="element-80">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-81">
                  Subject
                </label>
                <input type="text" id="subject" value={formData.subject} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors" placeholder="How can we help?" data-id="element-82" />
              </div>
              <div data-id="element-83">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-84">
                  Message
                </label>
                <textarea id="message" rows={4} value={formData.message} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors" placeholder="Tell us about your project..." required data-id="element-85"></textarea>
              </div>
              {status.error && <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm" data-id="element-86">
                  {status.error}
                </div>}
              <button type="submit" disabled={status.submitting} className={`px-6 py-3 ${status.submitting ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'} text-white rounded-lg transition-colors flex items-center gap-2`} data-id="element-87">
                {status.submitting ? 'Sending...' : 'Send Message'}{' '}
                <SendIcon size={18} data-id="element-88" />
              </button>
            </form>
          </div>
          <div data-id="element-89">
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 mb-8" data-id="element-90">
              <h3 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-91">
                Our Location
              </h3>
              <div className="space-y-6" data-id="element-92">
                <div className="flex items-start gap-4" data-id="element-93">
                  <div className="mt-1" data-id="element-94">
                    <MapPinIcon size={24} className="text-blue-600" data-id="element-95" />
                  </div>
                  <div data-id="element-96">
                    <h4 className="font-medium text-gray-800" data-id="element-97">Find Us</h4>
                    <p className="text-gray-600" data-id="element-98">Pompano Beach, Florida</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}